import { createAction, props } from "@ngrx/store";

import { Coordinates } from "@hermes/api-model-common";
import { FindShopsParameters } from "@hermes/shop-utils";

import {
    HoveredShopEventOrigin,
    SelectedLocationCity,
    SelectedLocationCoordinates,
    SelectedLocationCountry,
    ShopLocatorExtraInfos,
    ShopLocatorMode,
    ShopsStateData,
} from "../reducers/shop-locator.state";

export const fetchShops = createAction(
    "[Shop Locator] Fetch shops",
    props<{ parameters: FindShopsParameters }>(),
);

export const fetchShopsSuccess = createAction(
    "[Shop Locator] The fetch of shops is a success",
    props<{ shops: ShopsStateData; parameters: FindShopsParameters }>(),
);

export const fetchShopsFailure = createAction(
    "[Shop Locator] The fetch of shops failed",
    props<{ errorMessage: string }>(),
);

/**
 * Selected location shop action :
 */
export const setSelectedLocation = createAction(
    "[Shop Locator] Set selected location coordinates",
    props<
        | SelectedLocationCoordinates
        | SelectedLocationCity
        | SelectedLocationCountry
    >(),
);

/**
 * Hovered shop action :
 */
export const setHoveredShop = createAction(
    "[Shop Locator] Update hovered shop",
    props<{
        shopId: string;
        coordinates: Coordinates;
        origin: HoveredShopEventOrigin;
    }>(),
);
export const unsetHoveredShop = createAction(
    "[Shop Locator] Unset hovered shop",
);

/**
 * Control shops to be displayed or not
 */
export const setVisibleShopIds = createAction(
    "[Shop Locator] Update visible shops",
    props<{
        visibleShopIds: string[];
        source: "map" | "effect";
    }>(),
);

export const setShopIdsToIgnore = createAction(
    "[Shop Locator] Update shop IDs to ignore and not to be displayed",
    props<{
        shopIdsToIgnore: string[];
    }>(),
);

/**
 * Customize the Shop Locator mode : with ou without map.
 */
export const setMode = createAction(
    "[Shop Locator] Update Shop Locator mode (with ou without map)",
    props<{
        mode: ShopLocatorMode;
    }>(),
);

/**
 * Set informations about shops according the current selected location
 */
export const setExtraInfos = createAction(
    "[Shop Locator] Update extra information about shops (direction URL & meters)",
    props<{
        extraInfos: ShopLocatorExtraInfos;
    }>(),
);

/**
 * Others :
 */
export const resetShopLocator = createAction(
    "[Shop Locator] Reset Shop Locator data (only keep the shops list)",
);
